// generated by the plop

export interface TrafficAccessStateModel {
  canReadTraffic: boolean;
  canReadTrafficById: boolean;
  canSaveForce: boolean;
  canWriteTraffics: boolean;
  canRemoveTemplate: boolean;
}

export const TRAFFIC_ACCESS_STATE_DEFAULT: TrafficAccessStateModel = {
  canReadTraffic: false,
  canReadTrafficById: false,
  canSaveForce: false,
  canWriteTraffics: false,
  canRemoveTemplate: false
};


